import { render, staticRenderFns } from "./NavBarUser.vue?vue&type=template&id=21ddcf6c&"
import script from "./NavBarUser.vue?vue&type=script&lang=js&"
export * from "./NavBarUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports